import { InputAdornment, Stack } from '@mui/material';
import TextInput, { TextInputProps } from 'components/Common/TextInput';

interface FieldProps extends TextInputProps {
    endAdornmentValue?: string | number;
}

interface ActivityHeaderProps {
    fields: FieldProps[];
}

const ActivityHeader = ({ fields = [] }: ActivityHeaderProps) => {
    return (
        <Stack direction="row" mb={2} gap={2}>
            {fields.map((field, index) => {
                const { endAdornmentValue } = field;
                return (
                    <TextInput
                        key={index}
                        backgroundColor="#F2F2F6"
                        height="50px"
                        width="30%"
                        icon={null}
                        disabled
                        InputProps={{
                            endAdornment: <InputAdornment position="end">{endAdornmentValue}</InputAdornment>,
                        }}
                        {...field}
                    />
                );
            })}
        </Stack>
    );
};

export default ActivityHeader;
